module.exports = __webpack_public_path__ + "static/media/goodnest_job1.b7d65b2b.jpg";